import { t } from './i18n';
export default {
    err: (err) => {
        if (err.code) {
            let tCode = t('firebase.err');
            if (err.code && tCode[err.code]) {
                return tCode[err.code];
            }
        }
        else {
            return err.message || 'Unknown: ' + err;
        }
    }
};
